export const environment = {
  appVersion: 'integration',
  production: true,
};
